"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupLinks = groupLinks;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _transform = _interopRequireDefault(require("./transform"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function groupLinks(links) {
  var transformedLinks = (0, _transform["default"])(links);
  var individualLinks = getIndividualLinks(transformedLinks);
  var linkGroups = createLinkGroups(transformedLinks);
  var mergedLinks = mergeLinks(individualLinks, linkGroups);
  return sortLinks(mergedLinks);
}

function getIndividualLinks(links) {
  return links.filter(function (_ref) {
    var groupName = _ref.groupName;
    return !groupName;
  });
}

function createLinkGroups(links) {
  return links.reduce(function (linkGroups, link) {
    var groupName = link.groupName;

    if (groupName) {
      return _objectSpread(_objectSpread({}, linkGroups), {}, (0, _defineProperty2["default"])({}, groupName, linkGroups[groupName] ? [].concat((0, _toConsumableArray2["default"])(linkGroups[groupName]), [link]) : [link]));
    }

    return linkGroups;
  }, {});
}

function mergeLinks(individualLinks, groupedLinks) {
  return [].concat((0, _toConsumableArray2["default"])(individualLinks), (0, _toConsumableArray2["default"])(_lodash["default"].values(groupedLinks))).map(function (linkOrGroup) {
    if (_lodash["default"].isArray(linkOrGroup)) {
      var firstGroupItem = linkOrGroup[0];
      var groupName = firstGroupItem.groupName,
          navigationPriority = firstGroupItem.navigationPriority;
      return {
        navigationPriority: navigationPriority,
        title: groupName,
        links: linkOrGroup
      };
    }

    return linkOrGroup;
  });
}

function sortLinks(links) {
  return _lodash["default"].sortBy(links, ['navigationPriority']);
}